import React from 'react'
import LoginCard from '../Components/Login/LoginCard'
import CommonLayout from '../Components/Common/CommonLayout'
import { Outlet } from 'react-router'


function Login() {
  return (
    <main>
      <CommonLayout>
      <Outlet/>
      </CommonLayout>
    </main>
  )
}

export default Login